module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/step_back_icon-c2f59c17317391d8ff6ab46d4ed5019d.svg";